/**
 * Sage credits single source of truth.
 *
 * localStorage is the authoritative client-side value. Every screen that
 * displays credits should read via `getSageCredits()` and listen for the
 * `credits-updated` DOM event. Every write should go through
 * `setSageCredits(n)` which persists + broadcasts the event so that
 * floating badges, tabs, and modals stay in sync across the app.
 */

export const SAGE_CREDITS_KEY = 'sage_credits';
export const SAGE_CREDITS_EVENT = 'credits-updated';

export function getSageCredits() {
  const n = parseInt(localStorage.getItem(SAGE_CREDITS_KEY) || '0', 10);
  return Number.isFinite(n) ? n : 0;
}

export function setSageCredits(value) {
  const n = Math.max(0, Number.isFinite(+value) ? Math.floor(+value) : 0);
  localStorage.setItem(SAGE_CREDITS_KEY, String(n));
  // Dispatch on same tab (storage event only fires for OTHER tabs)
  try {
    window.dispatchEvent(new Event(SAGE_CREDITS_EVENT));
  } catch {}
  return n;
}
